module.exports = __webpack_public_path__ + "static/empaques-11fb0183ff2968a518449433b928b0cd.png";